/**
 * Detect video platform from URL and return an embed config
 * { platform, embedUrl, aspect } or null if unsupported.
 */
export function parseVideoUrl(raw) {
    if (!raw || typeof raw !== "string") return null;
    const url = raw.trim();
    if (!url) return null;

    // YouTube — watch, shorts, youtu.be
    let m =
        url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{6,})/i);
    if (m) {
        return {
            platform: "youtube",
            id: m[1],
            embedUrl: `https://www.youtube.com/embed/${m[1]}?rel=0`,
            aspect: url.includes("/shorts/") ? "9/16" : "16/9",
        };
    }

    // TikTok — regular and vt.tiktok.com short URLs
    m = url.match(/tiktok\.com\/(?:@[^/]+\/video|v|embed)\/(\d+)/i);
    if (m) {
        return {
            platform: "tiktok",
            id: m[1],
            embedUrl: `https://www.tiktok.com/player/v1/${m[1]}?autoplay=0&music_info=1&description=1`,
            aspect: "9/16",
        };
    }
    if (/vt\.tiktok\.com\//i.test(url)) {
        // short URL — we can't resolve without a redirect; use the plain URL as an iframe src
        // Player won't work but user can still click through; fall back to embed via oEmbed proxy.
        return {
            platform: "tiktok",
            id: null,
            embedUrl: `https://www.tiktok.com/embed/v2?url=${encodeURIComponent(url)}`,
            aspect: "9/16",
        };
    }

    // Facebook — watch, reel, videos, fb.watch
    if (/facebook\.com\/(?:watch\/?\?v=|reel\/|.+\/videos\/)/i.test(url) || /fb\.watch\//i.test(url)) {
        return {
            platform: "facebook",
            id: null,
            embedUrl: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
                url
            )}&show_text=false`,
            aspect: /reel\//i.test(url) ? "9/16" : "16/9",
        };
    }

    return null;
}
